
import React, { Component } from 'react';
import { PLAYERS_TEMPLATES_FILES_TXT } from '../../constants';
import PlayersTemplateFileRows from './PlayersTemplateFileRows';

class PlayersTemplateFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileSelected: null,
      inputLabel: PLAYERS_TEMPLATES_FILES_TXT.inputLabel,
      hasError: false,
    };
  }

  onChangeInputFile = (event) => {
    const file = event.target.files[0];
    if (!file) {
      this.setState({
        fileSelected: null,
        hasError: false,
        inputLabel: PLAYERS_TEMPLATES_FILES_TXT.inputLabel,
      });
    } else {
      const fileName = file.name;
      const extention = fileName?.substring(fileName.lastIndexOf('.') + 1, fileName?.length);
      if (PLAYERS_TEMPLATES_FILES_TXT.validExtentions.includes(extention)) {
        this.setState({
          fileSelected: event.target.files[0],
          hasError: false,
          inputLabel: fileName,
        });
      } else {
        this.setState({
          inputLabel: PLAYERS_TEMPLATES_FILES_TXT.inputLabel,
          hasError: true,
        });
      }
    }
  };

  uploadPlayersTemplateFile = () => {
    this.props.uploadPlayersTemplateFileRequest(
      this.state.fileSelected,
    );
    this.setState({
      fileSelected: null,
      inputLabel: PLAYERS_TEMPLATES_FILES_TXT.inputLabel,
    });
  };

  render() {
    return (
      <div>
        {this.props.hasPermissionToView && (
          <div className="table-responsive m-t-30 fix-12">
            <table className="odds__table">
              <thead className="thead--green is-fix">
                <tr className="tr--primary">
                  <th>Name</th>
                  <th>
                    Inserted Date
                    <i className="table-arrow ml-1" />
                  </th>
                  <th>User</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <PlayersTemplateFileRows
                  playerTemplateFileList={this.props.playersTemplateFile}
                  hasPermissionToDownload={this.props.hasPermissionToDownload}
                  downloadPlayersTemplatesFile={this.props.downloadPlayersTemplatesFile}
                />
              </tbody>
            </table>
          </div>
        )}
        {this.props.hasPermissionToUpload && (
          <div className="content__wrapper-section m-t-30">
            <div className="d-flex align-items-center">
              <div className="content__wrapper-sectionLabel">
                <strong>Upload new file </strong>
                (*File accepted: xlsx, xls)
              </div>
              <div className="m-l-30">
                <input type="file" className="d-none" id="file" onChange={this.onChangeInputFile} />
                <label htmlFor="file" className="m-0"><div className="file-btn">{this.state.inputLabel}</div></label>
              </div>
              <button
                type="button"
                className="btn btn-primary m-l-20"
                onClick={this.uploadPlayersTemplateFile}
                disabled={
                  !this.state.fileSelected
                  || this.state.hasError
                }
              >
                Upload
              </button>
            </div>
            {this.state.hasError && <div className="error-txt mt-2">{PLAYERS_TEMPLATES_FILES_TXT.inputErrorMgs}</div>}
          </div>
        )}
        <div className="content__wrapper-info m-t-30">*Uploaded files will be displayed in the table(s) above</div>
      </div>
    );
  }
}

export default PlayersTemplateFile;
